/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import consultaApi from '../../../services/consultaApi';
import Carousel from 'react-material-ui-carousel';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import paraMoedaReal from '../../../tools/paraMoedaReal';

const useStyles = makeStyles(theme => ({
    controlaCarousel: {
        height: 170,
        marginBottom: 30,
        padding: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
}))

function Conteudo(props) {

    const { item } = props;

    return (
        <>
            <Typography
                variant="h5"
                component="h5"
                gutterBottom
                align="center"
                color="primary"
            >
                {item.titulo}
            </Typography>
            <Typography
                variant="h3"
                component="h3"
                gutterBottom
                align="center"
                color="secondary"
            >
                {item.moeda ? paraMoedaReal(item.valor, 2) : item.valor}
            </Typography>
        </>
    )
}

export default function DashboardHome(props) {

    const classes = useStyles();

    const [resumos, setResumos] = useState([]);
    const [loading, setLoading] = useState(false)

    async function consultaBanco() {
        setLoading(true);
        let procedure = {
            PROCNAME: "WEBSITE_TOTAIS_HOME",
        }

        const resposta = await consultaApi(procedure);

        let respostaDados = resposta.data;
        setLoading(false);

        if (respostaDados) {
            return respostaDados;
        }
    }

    async function pesquisar() {
        let retornoFunction = await consultaBanco();
        setResumos(retornoFunction)
    }

    useEffect(() => {
        pesquisar();
    }, [])

    var items = [
        {
            titulo: "Total de Vendas Este Mês",
            valor: resumos.TOTAL_MES,
            moeda: true
        },
        {
            titulo: "Total de Vendas Hoje",
            valor: resumos.TOTAL_DIA,
            moeda: true
        },
        {
            titulo: "Média de Vendas Diárias",
            valor: resumos.MEDIA_DIA,
            moeda: true
        },
        {
            titulo: "Notas Canceladas este mês",
            valor: resumos.TOTAL_CANCELADAS_MES,
            moeda: false
        },
        {
            titulo: "Notas Pendentes",
            valor: resumos.TOTAL_PENDENTES,
            moeda: false
        },
        {
            titulo: "Total de notas autorizadas este mês",
            valor: resumos.TOTAL_EMITIDAS_MES,
            moeda: false
        },
    ]

    return (
        <Grid item align="center" xs={12} id="dashboard-home">
            <Paper className={classes.controlaCarousel}>
                {!loading ?
                    <Carousel navButtonsAlwaysInvisible animation="slide">
                        {items.map((item, i) => <Conteudo key={i} item={item} />)}
                    </Carousel>
                    : <CircularProgress />
                }
            </Paper>
        </Grid >
    )
}